module.exports =
  invoice: '/statement/billing/:billingId/invoice/:invoiceId'
  billing: '/statement/billing/:billingId'

  mockup:
    design: '/statement/mockup/design'



// WEBPACK FOOTER //
// ./~/oo-routes/routes/statement.coffee